import { Pipe, PipeTransform } from '@angular/core';
import { MinimumSlideInformation, Slide } from "@pcp/core/interfaces";
import { isDynamicExtensionSlide } from '@pcp/core/util';

@Pipe({
    name: 'isDynamicExtensionSlide',
    pure: true
})
export class IsDynamicExtensionSlidePipe implements PipeTransform {
    transform(slide: Slide|MinimumSlideInformation): boolean {
        return isDynamicExtensionSlide(slide);
    }
}
